<template>
  <div
    class="footer"
    :class="{ 'transparent-bg': transparentBg }"
    :style="{ color: fontColor }"
  >
    <!--云采购默认页脚-->
    <template v-if="platformConfig.alias === 'default'">
      <div>
        <div class="friendly-links">
          友情链接：
          <el-link :underline="false" href="http://www.jxzxtz.com">
            江西省咨询投资集团有限公司
          </el-link>
          <el-link :underline="false" href="http://www.jxbidding.com">
            江西省机电设备招标有限公司
          </el-link>
          <el-link :underline="false" href="http://www.gxbidding.com">
            广西机电设备招标有限公司
          </el-link>
        </div>
      </div>
      <div class="copy-right">
        <span>Copyright©2017-{{ currentYear }} 精彩纵横 版权所有</span>
        <a href="https://beian.miit.gov.cn/">赣ICP备17007647号-6</a>
        <span>赣B2-20180066</span>
      </div>
    </template>

    <!--国资登录平台页脚-->
    <template
      v-else-if="
        platformConfig.alias === 'gz' || platformConfig.alias === 'xygz'
      "
    >
      <div>
        <span>承办单位：江西省咨询投资集团有限公司</span>
        <span>运营主体：精彩纵横云采购平台</span>
      </div>
      <div>
        <span>联系电话：{{ consumerHotline }}</span>
        <span>邮编：330000</span>
        <span>联系地址：江西省南昌市红谷滩区春晖路6号新龙大厦18楼东</span>
      </div>
    </template>

    <!--其他平台页脚-->
    <template v-else>
      <div>
        <div class="friendly-links">
          友情链接：
          <el-link
            v-for="item in friendlyLinks"
            :key="item.name"
            :underline="false"
            :href="item.url"
          >
            {{ item.name }}
          </el-link>
        </div>
      </div>
      <div class="copy-right">
        <span class="m-r-4">{{ platformConfig.footer?.copyright || '' }}</span>
        <span>版权所有</span>
        <span>
          网络备案号：
          <a href="https://beian.miit.gov.cn/">
            {{ platformConfig.footer?.beian }}
          </a>
        </span>
        <span>地址：{{ platformConfig.footer?.address }}</span>
        <span>|</span>
        <span>
          技术支持：
          <el-link :underline="false" href="https://www.yingcaicheng.com">
            江西省精彩纵横采购咨询有限公司
          </el-link>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'FooterComponent',

  props: {
    // 透明底
    transparentBg: {
      type: Boolean,
      default: false
    },

    // 文字颜色
    fontColor: {
      type: String,
      default: '#ffffff'
    }
  },

  computed: {
    ...mapState('system', ['systemTime', 'consumerHotline']),
    ...mapGetters('system', ['platformConfig']),

    currentYear() {
      const current = new Date(this.systemTime)

      return current.getFullYear()
    },

    friendlyLinks() {
      return [
        {
          name: '江西省国有企业采购交易服务平台',
          url: 'https://www.jxgqcg.com/'
        },
        { name: '江西省公共资源交易平台', url: 'https://ggzy.jiangxi.gov.cn' },
        {
          name: '中国招标投标公共服务平台',
          url: 'http://www.cebpubservice.com'
        }
      ]
    }
  },

  created() {
    this.$store.dispatch('system/getSystemTime')
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width: 100%;
  min-width: pixel-to-rem($n: 1420);
  max-height: pixel-to-rem($n: 200);
  background-color: $background-black-color;
  font-size: pixel-to-rem($n: 14);
  padding: pixel-to-rem($n: 20);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  // 透明底
  &.transparent-bg {
    background-color: transparent;
  }

  span {
    margin-right: 16px;
  }

  .friendly-links {
    color: inherit;
    display: flex;
    align-items: center;
    font-size: 14px;
    ::v-deep .el-link {
      color: inherit;
      margin-right: 16px;
      font-size: inherit;
      &:not(:last-child) {
        &::after {
          display: inline-block;
          content: '|';
          margin-left: 16px;
        }
      }

      .el-link--inner {
        &:hover {
          color: $primary-color;
        }
      }
    }
  }

  div {
    margin-bottom: 4px;
    &:last-child {
      margin-top: 8px;
    }
  }

  .copy-right {
    font-size: 14px;

    span {
      color: inherit;
    }

    a {
      color: inherit;
      text-decoration: none;
      // font-size: pixel-to-rem($n: 14);

      &:hover {
        color: $primary-color;
      }
    }
  }
}
</style>
